import { render, staticRenderFns } from "./rewardCarnivalEdit.vue?vue&type=template&id=509701a2&scoped=true&"
import script from "./rewardCarnivalEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCarnivalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509701a2",
  null
  
)

export default component.exports